const config = {};

if (process.env.NODE_ENV === 'development' ) {
  config.api_url = 'https://api.vicentelopez.gov.ar';
} else {
  config.api_url = 'https://api.vicentelopez.gov.ar';
}

export default config;



// WEBPACK FOOTER //
// ./src/config.js